module.exports = __webpack_public_path__ + "static/media/azaelcom.7b15c4e5.jpg";